import { Currency, CurrencyBadge, CurrencyKey } from './Currency';
import { formatCurrency } from '../currencyFormatter';
import { getCurrencyOverride } from '../../hooks/useCurrencyOverride';

interface IMoney {
  toString(): string;
  toAPI(): MoneyFromAPI;
}

export class Money implements IMoney {
  public amount: number;
  public currency: Currency;
  public decimals: number;

  constructor(moneyFromAPI: MoneyFromAPI) {
    this.amount = moneyFromAPI.amount;
    this.currency = new Currency(moneyFromAPI.currency);
    this.decimals = moneyFromAPI.decimals;
  }

  public toString(): string {
    // Apply currency override from DevTools if present
    const displayCurrency = getCurrencyOverride(this.currency.key as any);
    
    // Use the new currency formatter for proper locale formatting
    return formatCurrency({
      amount: this.amount,
      currency: displayCurrency,
      decimals: this.decimals,
    });
  }

  public toAPI(): MoneyFromAPI {
    return {
      amount: this.amount,
      currency: this.currency.key,
      decimals: this.decimals,
    };
  }

  private formatValue(): { number: () => number; string: () => string } {
    const formattedValue: number = this.amount / Math.pow(10, this.decimals);
    const valueToString: string = formattedValue.toLocaleString();

    return { number: () => formattedValue, string: () => valueToString };
  }
}

export interface MoneyFromAPI {
  amount: number;
  currency: CurrencyKey;
  decimals: number;
}
